import React from 'react';
import { Modal, ModalBody } from 'reactstrap';

const JobDetailModal = ({ isOpen, toggle, container, jobDetails }) => {
  // console.log(jobDetails);
  return (
    <Modal isOpen={isOpen} toggle={toggle} container={container} className="modal-md">
      <div className="modal-header">
        <button type="button" className="close" onClick={toggle}>
          &times;
        </button>
      </div>
      <ModalBody style={{ padding: '0 30px 30px' }}>
        <div className="reson-reject" style={{ padding: '0px 0px' }}>
          <h2 className="text-center" style={{ marginBottom: '20px' }}>
            Details
          </h2>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '8px',
            }}
          >
            <p style={{ fontSize: 20, textAlign: 'left' }}>
              <strong>Importer</strong>:
            </p>
            <p style={{ fontSize: 20, textAlign: 'left' }}>
              {jobDetails?.client?.first_name
                ? jobDetails.client.first_name + ' ' + jobDetails?.client?.last_name
                : 'NA'}
            </p>

            {jobDetails?.job_type_tags?.find((type) => type === 'clearing') ? (
              <>
                <p style={{ fontSize: 20, textAlign: 'left' }}>
                  <strong>Clearing Agent</strong>:
                </p>
                <p style={{ fontSize: 20, textAlign: 'left' }}>
                  {jobDetails?.clearing_agent?.first_name
                    ? jobDetails.clearing_agent.first_name +
                      ' ' +
                      jobDetails?.clearing_agent?.last_name
                    : 'NA'}
                </p>
              </>
            ) : (
              <>
                <p style={{ fontSize: 20, textAlign: 'left' }}>
                  <strong>Transporter</strong>:
                </p>
                <p style={{ fontSize: 20, textAlign: 'left' }}>
                  {jobDetails?.forwarding_agent?.first_name
                    ? jobDetails.forwarding_agent.first_name +
                      ' ' +
                      jobDetails?.forwarding_agent?.last_name
                    : 'NA'}
                </p>
              </>
            )}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default JobDetailModal;
